// import { ExternalLink, Twitter } from "lucide-react";
import { Link } from "@tanstack/react-router";

const Footer = () => {
  return (
    <footer
      className="bg-secondary/50 py-16 px-6 md:px-10 relative overflow-hidden"
      id="contact"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <a
              href="/"
              className="text-2xl font-bold text-primary mb-6 inline-block"
            >
              aiEmailAgent<span className="text-blue-600">.</span>
            </a>
            <p className="text-muted-foreground mb-6">
              Automate your sales email replies with AI and close more deals
              while saving time.
            </p>
            <div className="flex space-x-4">
              {/* <a
                href="#"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a> */}
              {/* <a
								href="#"
								className="text-muted-foreground hover:text-primary transition-colors"
								aria-label="LinkedIn"
							>
								<Linkedin className="w-5 h-5" />
							</a>
							<a
								href="#"
								className="text-muted-foreground hover:text-primary transition-colors"
								aria-label="GitHub"
							>
								<Github className="w-5 h-5" />
							</a> */}
            </div>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Product</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="#features"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="#how-it-works"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  How It Works
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  Testimonials
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/blog"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/auth/login"
                  className="text-muted-foreground hover:text-primary transition-colors"
                  search={{
                    redirectTo: "/dashboard",
                  }}
                >
                  Login
                </Link>
              </li>
              {/* <li>
								<a
									href="#"
									className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-1"
								>
									Blog
								</a>
							</li>
							<li>
								<a
									href="#"
									className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-1"
								>
									Support Center
								</a>
							</li> */}
              {/* <li>
                <a
                  href="#"
                  className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-1"
                >
                  Documentation <ExternalLink className="w-3 h-3" />
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  API Reference
                </a>
              </li> */}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Contact Us</h3>
            <p className="text-muted-foreground mb-4">
              Have questions or want to learn more about aiEmailAgent?
            </p>
            <a
              href="mailto:contact@aiEmailAgent.com"
              className="btn-primary inline-block"
            >
              Contact Us
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} aiEmailAgent. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a
                href="#"
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Privacy Policy
              </a>
              <a
                href="#"
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Terms of Service
              </a>
              <a
                href="#"
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
